// @flow
// Export config from base.html. Might later add other stuff here.

const baseConfig = window.BASE_CONFIG || ({}: any);

export const SERVICE_NAME = 'web';

export const IS_IN_IFRAME = window.self !== window.top;
export const IS_IN_POPUP = !!window.opener;

const config = {
  ...baseConfig,
  IS_IN_IFRAME,
  IS_IN_POPUP,
  SERVICE_NAME,
};

export default config;
